import template from './hueb-seo-article.html.twig';

const { Component, Mixin } = Shopware;
const { Criteria } = Shopware.Data;

Component.extend('hueb-seo-article', 'hueb-seo-category', {
    template,

    inject: ['systemConfigApiService', 'repositoryFactory'],

    mixins: [ Mixin.getByName('notification') ],

    data() {
        return {
            articleRepository: null,
            metaTitle: '',
            metaDescription: '',
            keywords: '',
            fallbackArticle: null,
            fallbackManufacturer: null,
            previewEntityManufacturer: null,
            manufacturerRepository: null,
            variant: false
        }
    },

    methods: {
        async createdComponent() {
            this.setBlockSize();
            this.setCleanNames();
            this.setWhitelist();
            this.categoryRepository = this.repositoryFactory.create('category');
            this.articleRepository = this.repositoryFactory.create('product');
            this.templateRepository = this.repositoryFactory.create('hueb_seo_ultimate_templates');
            this.templateSaveRepository = this.repositoryFactory.create('hueb_seo_ultimate_templates_saved');
            this.salesChannelDomainRepository = this.repositoryFactory.create('sales_channel_domain');
            this.robotsTagRepository = this.repositoryFactory.create('hueb_seo_ultimate_robot_tags');
            this.manufacturerRepository = this.repositoryFactory.create('product_manufacturer');
            this.robotOptions = [{value: '00', label: this.$tc('hueb-seo.card.robot00')},
                {value: '01', label: this.$tc('hueb-seo.card.robot01')},
                {value: '10', label: this.$tc('hueb-seo.card.robot10')},
                {value: '11', label: this.$tc('hueb-seo.card.robot11')}];
            this.createVariableOptions(this.articleRepository, "product");
            this.createVariableOptions(this.manufacturerRepository, "product_manufacturer");
            this.addManualVariables();
            this.createTemplateOptions("product");
            this.createFallbackArticle();
        },

        setCleanNames() {
            this.cleanNames = [
                {value: "product.translated.name", label: "Produktname (Übersetzung)"},
                {value: "product.productNumber", label: "Produktnummer"},
                {value: "product_manufacturer.name", label: "Hersteller"},
                {value: "product.weight", label: "Gewicht"},
                {value: "product.width", label: "Breite"},
                {value: "product.height", label: "Höhe"},
                {value: "product.length", label: "Länge"}
            ]
        },
        setWhitelist() {
            this.whitelist = [
                "product_manufacturer.link",
                "product_manufacturer.name",
                "product_manufacturer.description",
                "product_manufacturer.customFields",
                "product_manufacturer.translated.name",
                "product_manufacturer.translated.description",
                "product.productNumber",
                "product.stock",
                "product.restockTime",
                "product.availableStock",
                "product.available",
                "product.displayGroup",
                "product.configuratorGroupConfig",
                "product.variantRestrictions",
                "product.manufacturerNumber",
                "product.ean",
                "product.purchaseSteps",
                "product.maxPurchase",
                "product.minPurchase",
                "product.purchaseUnit",
                "product.referenceUnit",
                "product.purchasePrice",
                "product.weight",
                "product.width",
                "product.height",
                "product.length",
                "product.releaseDate",
                "product.ratingAverage",
                "product.sales",
                "product.name",
                "product.description",
                "product.packUnit",
                "product.packUnitPlural",
                "product.customFields",
                "product.customSearchKeywords",
                "product.translated.name",
                "product.translated.keywords",
                "product.translated.description",
                "product.translated.packUnit",
                "product.translated.packUnitPlural",
                "product.translated.customSearchKeywords",
                "product.id",
            ]
        },
        addManualVariables() {
            const variables = [
                {value: "{{ product.variation.0.group }}", label: "Variantengruppe (product.variation.0.group)"},
                {value: "{{ product.variation.0.option }}", label: "Variantenwert (product.variation.0.option)"},
                {value: "{{ product.properties.0.name }}", label: "Ausprägung (product.properties.0.name)"},
                {value: "{{ product.properties.0.group.name }}", label: "Eigenschaft (product.properties.0.group.name)"}
            ];
            this.categoryOptions = this.categoryOptions.concat(variables);
        },
        createFallbackArticle() {
            let articleCriteria = new Criteria();
            //articleCriteria.addFilter(Criteria.not(Criteria.equals('product_manufacturer_id', null)));
            //articleCriteria.addFilter(Criteria.equals('autoIncrement', 1));
            articleCriteria.addAssociation('seoUrls');
            articleCriteria.addAssociation('properties');
            articleCriteria.addAssociation('properties.group');
            this.articleRepository.search(articleCriteria, Shopware.Context.api)
                .then((entity) => {
                    if(entity.length) {
                        this.fallbackArticle = entity[0];
                        this.manufacturerRepository.get(entity[0].manufacturerId, Shopware.Context.api).
                            then((manufacturer) => {
                                if (manufacturer) {
                                    this.fallbackManufacturer = manufacturer;
                                }
                        });
                    }
                });
        },

        setBlockSize() {
            this.systemConfigApiService.getValues('HuebertSeoUltimate.config')
                .then((entity) =>{
                    if(entity && entity['HuebertSeoUltimate.config.blockSize'] > 0) {
                        this.blockSize = entity['HuebertSeoUltimate.config.blockSize'];
                    } else {
                        this.blockSize = 100;
                    }
                });
        },

        clickItem(item) {
            let categoryCriteria = new Criteria();
            categoryCriteria.getAssociation('products').setLimit(1);
            categoryCriteria.addAssociation('products.seoUrls');
            categoryCriteria.addAssociation('children');
            categoryCriteria.getAssociation('children.products').setLimit(1);
            categoryCriteria.addAssociation('children.products.seoUrls');
            categoryCriteria.addAssociation('products.properties');
            categoryCriteria.addAssociation('products.properties.group');
            this.categoryRepository.get(item.id, Shopware.Context.api, categoryCriteria)
                .then((entity) => {
                    if(entity.products[0]) {
                        if(entity.products[0].manufacturerId) {
                            this.manufacturerRepository.get(entity.products[0].manufacturerId, Shopware.Context.api)
                                .then((manufacturer) => {
                                    if (manufacturer) {
                                        this.previewEntityManufacturer = manufacturer;
                                        this.previewEntity = entity.products[0];
                                        this.updatePreview();
                                    } else {
                                        this.previewEntityManufacturer = null;
                                        this.previewEntity = entity.products[0];
                                        this.updatePreview();
                                    }
                                });
                        } else {
                            this.previewEntityManufacturer = null;
                            this.previewEntity = entity.products[0];
                            this.updatePreview();
                        }
                    } else if(entity.children.length) {
                        let i;
                        for(i = 0; i < entity.childCount; i++) {
                            let currentChild = entity.children[i];
                            if(currentChild.products.length) {
                                if(currentChild.products[0].manufacturerId) {
                                    this.manufacturerRepository.get(currentChild.products[0].manufacturerId, Shopware.Context.api)
                                        .then((manufacturer) => {
                                            if (manufacturer) {
                                                this.previewEntityManufacturer = manufacturer;
                                                this.previewEntity = currentChild.products[0];
                                                this.updatePreview();
                                            } else {
                                                this.previewEntityManufacturer = null;
                                                this.previewEntity = currentChild.products[0];
                                                this.updatePreview();
                                            }
                                        });
                                } else {
                                    this.previewEntityManufacturer = null;
                                    this.previewEntity = currentChild.products[0];
                                    this.updatePreview();
                                }
                                break;
                            }
                        }
                        if(!this.previewEntity) {
                            this.previewEntity = this.fallbackArticle;
                            this.previewEntityManufacturer = this.fallbackManufacturer;
                            this.updatePreview();
                        }
                    } else {
                        this.previewEntity = this.fallbackArticle;
                        this.previewEntityManufacturer = this.fallbackManufacturer;
                        this.updatePreview();
                    }
                });

            /*this.templateRepository.get(item.id, Shopware.Context.api)
                .then((entity) => {
                    if(entity) {
                        if(entity.templateProductMetaTitle) {
                            this.metaTitle = entity.templateProductMetaTitle;
                        } else {
                            this.metaTitle = '';
                        }
                        if(entity.templateProductMetaTitle) {
                            this.metaDescription = entity.templateProductMetaDescription;
                        } else {
                            this.metaDescription = '';
                        }
                        if(entity.templateProductMetaTitle) {
                            this.keywords = entity.templateProductKeywords;
                        } else {
                            this.keywords = '';
                        }
                    } else {
                        this.metaTitle = '';
                        this.metaDescription = '';
                        this.keywords = '';
                    }
                })*/
        },
        onChangeMetaTitle() {
            this.setVariables();
            if(this.metaTitle && this.previewEntity) {
                this.metaTitlePreview = this.getVariables(this.metaTitle, this.metaTitleVariables, this.previewEntity, this.previewEntityManufacturer);
            } else if(!this.previewEntity) {
                this.metaTitlePreview = this.$tc('hueb-seo.general.placeholderPreviewArticle');
            } else {
                this.metaTitlePreview = this.$tc('hueb-seo.card.labelMetaTitle');
            }

        },
        onChangeMetaDescription() {
            this.setVariables();
            if(this.metaDescription && this.previewEntity) {
                this.metaDescriptionPreview = this.getVariables(this.metaDescription, this.metaDescriptionVariables, this.previewEntity, this.previewEntityManufacturer);
            } else if(!this.previewEntity) {
                this.metaDescriptionPreview = this.$tc('hueb-seo.general.placeholderPreviewArticle');
            } else {
                this.metaDescriptionPreview = this.$tc('hueb-seo.card.labelMetaDescription');
            }
        },
        onChangeKeywords() {
            this.setVariables();
            this.keywordsPreview = this.getVariables(this.keywords, this.keywordsVariables, this.previewEntity, this.previewEntityManufacturer);
            if(!this.previewEntity && this.keywordsActive) {
                this.keywordsPreview = this.$tc('hueb-seo.general.placeholderPreviewArticle');
            }
        },

        setVariables() {
            const regexp = /\{\{(.*?)\}\}/g;

            this.metaTitleVariables = [];
            this.metaDescriptionVariables = [];
            this.keywordsVariables = [];

            if(this.metaTitleActive && this.metaTitle)
                this.metaTitleVariables = Array.from(this.metaTitle.matchAll(regexp));
            if(this.metaDescriptionActive && this.metaDescription)
                this.metaDescriptionVariables = Array.from(this.metaDescription.matchAll(regexp));
            if(this.keywordsActive && this.keywords)
                this.keywordsVariables = Array.from(this.keywords.matchAll(regexp));

            this.metaTitleVariables.forEach(item => {
                let splitStr = item[1].replace(/\s+|(product\.)/g, '').toString();
                item[1] = splitStr.split(".");
            });
            this.metaDescriptionVariables.forEach(item => {
                let splitStr = item[1].replace(/\s+|(product\.)/g, '').toString();
                item[1] = splitStr.split(".");
            });
            this.keywordsVariables.forEach(item => {
                let splitStr = item[1].replace(/\s+|(product\.)/g, '').toString();
                item[1] = splitStr.split(".");
            });
        },
        getVariables(inputString, variableArray, entity, entityManufacturer = null) {
            variableArray.forEach(item => {
                if(item[1][0] == "product_manufacturer" && entityManufacturer) {
                    let solvedVariable = entityManufacturer[item[1][1]];
                    item[1].forEach((nested, key) => {
                        if (key > 1) {
                            if(typeof solvedVariable !== 'undefined') {
                                solvedVariable = solvedVariable[nested];
                            } else {
                                solvedVariable = '';
                            }
                        }
                    });
                    const type = typeof solvedVariable;
                    if (type === 'string' || type === 'number' || type === 'boolean') {
                        inputString = inputString.replace(item[0], solvedVariable);
                    } else {
                        solvedVariable = '';
                        inputString = inputString.replace(item[0], solvedVariable);
                    }
                } else if(item[1][0] == "product_manufacturer" && !entityManufacturer) {
                    let solvedVariable = '';
                    inputString = inputString.replace(item[0], solvedVariable);
                } else if(entity) {
                    let solvedVariable = entity[item[1][0]];
                    item[1].forEach((nested, key) =>{
                        if(key > 0) {
                            if(typeof solvedVariable !== 'undefined') {
                                solvedVariable = solvedVariable[nested];
                            } else {
                                solvedVariable = '';
                            }
                        }
                    });
                    const type = typeof solvedVariable;
                    if (type === 'string' || type === 'number' || type === 'boolean') {
                        inputString = inputString.replace(item[0], solvedVariable);
                    } else {
                        solvedVariable = '';
                        inputString = inputString.replace(item[0], solvedVariable);
                    }
                }
            });
            return String(inputString);
        },

        onClickDeleteTemplate() {
            if(this.templateSelected) {
                this.templateSaveRepository.delete(this.templateSelected, Shopware.Context.api)
                    .then(() => {
                        this.createTemplateOptions("product");
                    });
            }
        },

        onClickSaveNewTemplate(name = null) {
            this.isLoadingNewTemplate = true;

            const templateCriteria = new Criteria();
            templateCriteria.addFilter(Criteria.equals('name', this.templateName));

            this.templateSaveRepository.search(templateCriteria, Shopware.Context.api)
                .then((entity) => {
                    if (entity.length === 0 || entity[0].type !== "product") {
                        entity = this.templateSaveRepository.create(Shopware.Context.api);
                        entity.name = this.templateName;
                        entity.type = "product";
                    } else {
                        entity = entity[0];
                    }
                    entity.metaTitle = this.metaTitle;
                    entity.metaDescription = this.metaDescription;
                    entity.keywords = this.keywords;
                    this.templateSaveRepository.save(entity, Shopware.Context.api)
                        .then(() => {
                            this.createTemplateOptions("product");
                            this.isLoadingNewTemplate = false;
                            this.processSuccess = true;
                        })
                        .catch((exception) => {
                            this.isLoadingNewTemplate = false;
                            this.createNotificationError({
                                title: this.$tc('hueb-seo.general.placeholderError'),
                                message: exception
                            });
                        });
                });
        },

        saveGenerate() {
            let childIds = Object.keys(this.childList);
            let ids = Object.keys(this.checkedElements);
            //prohibit duplicates
            ids = childIds.concat(ids.filter((item) => childIds.indexOf(item) < 0));

            let categoryCriteria = new Criteria(1, ids.length);
            categoryCriteria.addFilter(Criteria.equalsAny('id', ids));
            categoryCriteria.addAssociation('products');
            categoryCriteria.addAssociation('products.properties');
            categoryCriteria.addAssociation('products.properties.group');

            //generate variant check
            let categoryContext = Shopware.Context.api;
            if(this.variant) {
                categoryContext = Object.assign({}, Shopware.Context.api, {inheritance: true});
                categoryCriteria.addAssociation('products.children');
                categoryCriteria.addAssociation('products.children.options');
                categoryCriteria.addAssociation('products.children.options.group');
                categoryCriteria.addAssociation('products.children.properties');
                categoryCriteria.addAssociation('products.children.properties.group');
                //categoryCriteria.addAssociation('products.children.properties.productOptions');
                //categoryCriteria.addAssociation('products.children.properties.productProperties');
                //categoryCriteria.addAssociation('products.children.options.translations');
                //categoryCriteria.addAssociation('products.children.variation');
                //categoryCriteria.addAssociation('products.children.options.productOptions');
            }

            this.manufacturerRepository.search(new Criteria(1, 500), Shopware.Context.api)
                .then((manufacturerArr) => {
                    this.categoryRepository.search(categoryCriteria, categoryContext)
                        .then((entities) => {
                            let productArray = [];
                            entities.forEach((entity) => {
                                //add variant products (children) if requested
                                let productCollection = entity.products;
                                if(this.variant) {
                                    productCollection = this.addVariantProducts(productCollection);
                                }
                                productCollection.forEach((product) => {
                                    if(product.manufacturerId) {
                                        manufacturerArr.every((manufacturer, key, manufacturerArr) => {
                                            if (manufacturer.id == product.manufacturerId) {
                                                if (this.metaTitleActive && (!product.metaTitle || this.overwrite)) {
                                                    product.metaTitle = this.getVariables(this.metaTitle, this.metaTitleVariables, product, manufacturer).substring(0, 255);
                                                }
                                                if (this.metaDescriptionActive && (!product.metaDescription || this.overwrite)) {
                                                    product.metaDescription = this.getVariables(this.metaDescription, this.metaDescriptionVariables, product, manufacturer).substring(0, 255);
                                                }
                                                if (this.keywordsActive && (!product.keywords || this.overwrite)) {
                                                    product.keywords = this.getVariables(this.keywords, this.keywordsVariables, product, manufacturer);
                                                }
                                                return false;
                                            } else if (Object.is(manufacturerArr.length - 1, key)) {
                                                //last iteration and no match:
                                                if (this.metaTitleActive && (!product.metaTitle || this.overwrite)) {
                                                    product.metaTitle = this.getVariables(this.metaTitle, this.metaTitleVariables, product).substring(0, 255);
                                                }
                                                if (this.metaDescriptionActive && (!product.metaDescription || this.overwrite)) {
                                                    product.metaDescription = this.getVariables(this.metaDescription, this.metaDescriptionVariables, product).substring(0, 255);
                                                }
                                                if (this.keywordsActive && (!product.keywords || this.overwrite)) {
                                                    product.keywords = this.getVariables(this.keywords, this.keywordsVariables, product);
                                                }
                                                return false;
                                            }
                                            return true;
                                        });
                                    } else {
                                        if (this.metaTitleActive && (!product.metaTitle || this.overwrite)) {
                                            product.metaTitle = this.getVariables(this.metaTitle, this.metaTitleVariables, product).substring(0, 255);
                                        }
                                        if (this.metaDescriptionActive && (!product.metaDescription || this.overwrite)) {
                                            product.metaDescription = this.getVariables(this.metaDescription, this.metaDescriptionVariables, product).substring(0, 255);
                                        }
                                        if (this.keywordsActive && (!product.keywords || this.overwrite)) {
                                            product.keywords = this.getVariables(this.keywords, this.keywordsVariables, product);
                                        }
                                    }
                                    productArray.push(product);
                                });
                                //this.saveTemplates(entity.id);
                            });
                            if(productArray.length <= this.blockSize) {
                                this.saveSmall(productArray);
                            } else {
                                this.bigProgress = 1;
                                this.isBig = true;
                                this.saveChunks(productArray);
                            }
                        });
                }).catch((exception) => {
                    this.isLoadingGenerate = false;
                    this.createNotificationError({
                        title: this.$tc('hueb-seo.general.placeholderError'),
                        message: exception
                    });
                });
        },

        saveTemplates(categoryId) {
            this.templateRepository.get(categoryId, Shopware.Context.api)
                .then((entity) => {

                    if(!entity) {
                        entity = this.templateRepository.create(Shopware.Context.api);
                        entity.id = categoryId;
                    }

                    if(this.metaTitleActive) {
                        entity.templateProductMetaTitle = this.metaTitle;
                    }
                    if(this.metaDescriptionActive) {
                        entity.templateProductMetaDescription = this.metaDescription;
                    }
                    if(this.keywordsActive) {
                        entity.templateProductKeywords = this.keywords;
                    }

                    this.templateRepository.save(entity, Shopware.Context.api);

                }).catch((exception) => {
                this.createNotificationError({
                    title: this.$tc('hueb-seo.general.placeholderError'),
                    message: exception
                });
            });
        },

        saveSmall(productArray) {
            this.saveRobotTags(productArray);
            this.articleRepository.sync(productArray, Shopware.Context.api)
                .then(() => {
                    this.isLoadingGenerate = false;
                    this.processSuccess = true;
                }).catch((exception) => {
                this.isLoadingGenerate = false;
                this.createNotificationError({
                    title: this.$tc('hueb-seo.general.placeholderError'),
                    message: exception
                });
            });
        },
        saveChunks(productArray) {
            let chunkArray = [];
            for (let i = 0; i < productArray.length; i += this.blockSize) {
                chunkArray.push(productArray.slice(i,i+this.blockSize));
            }
            let i = 0;
            let max = chunkArray.length ? chunkArray.length : 1;
            const runChunk = () => {
                this.articleRepository.sync(chunkArray[i], Shopware.Context.api)
                    .then(() => {
                        if(i < max - 1) {
                            i++;
                            this.bigProgress = 100/max * i;
                            runChunk();
                        } else {
                            this.bigProgress = 100;
                            setTimeout(() => {
                                this.isLoadingGenerate = false;
                                this.isBig = false;
                                this.processSuccess = true;
                            },2000);
                        }
                    }).catch((exception) => {
                    this.isLoadingGenerate = false;
                    this.isBig = false;
                    this.createNotificationError({
                        title: this.$tc('hueb-seo.general.placeholderError'),
                        message: exception
                    });
                });
            };
            runChunk();
        },

        addVariantProducts(productCollection) {
            let productCollectionFull = productCollection;
            productCollection.forEach((product) => {
                if(typeof product.children !== 'undefined') {
                    product.children.forEach((child) => {
                        productCollectionFull.push(child);
                    })
                }
            });
            return productCollectionFull;
        }

    }
});
